import { render, staticRenderFns } from "./HomeHeader.vue?vue&type=template&id=86fb9856&"
import script from "./HomeHeader.vue?vue&type=script&lang=js&"
export * from "./HomeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports